import Figure from "~/components/figure"
import RenderCofabComponent from "~/renderCofabComponent"
import CurvesRadial from "~/components/curvesRadial"
import { range } from "lodash"

const BannerRadial = ({ data }) => {
  const activeLayer = data.filter(({ layer }) => layer === "mixed3b")[0]

  const size = 400
  return (
    <CurvesRadial
      {...activeLayer}
      size={size}
      fillOpacity={0.4}
      orientationType={"max"}
    />
  )
}

export default class Banner extends Component {
  state = {}

  render() {
    const iconWidth = 100
    const sectionWidth = 520
    let i = 0

    const Section = ({ icon, title, children }) => (
      <Surface
        marginY={7}
        background="white"
        boxShadow="2px 8px 30px -3px rgba(50,50,93,.1)"
        overflow="hidden"
        borderRadius={6}
        width={sectionWidth}
        style={{ border: "1px solid rgba(0, 0, 0, 0.18)" }}
      >
        <Surface flexFlow="row">
          <div style={{ width: iconWidth, height: iconWidth }}>{icon}</div>
          <Surface paddingX={20} alignSelf="center" width="100%">
            <Surface
              flexFlow="row"
              paddingBottom={10}
              justifyContent="space-between"
              alignItems="center"
            >
              <Text size={600} fontWeight="bold">
                {title}
              </Text>
              <Text size={600} opacity={0.7} fontWeight="bold">
                Section {++i}
              </Text>
            </Surface>

            <Surface>{children}</Surface>
          </Surface>
        </Surface>
      </Surface>
    )

    const sectionFontSize = 18

    return (
      <Figure>
        <Surface flexFlow="row" marginY={20} alignItems="center">
          <Surface marginX={40} position="relative">
            <Surface>
              <Section
                title="Feature Visualization"
                icon={
                  <img
                    width={iconWidth}
                    height={iconWidth}
                    src={neuronFeatureVis("inceptionv1", "mixed3b", 342)}
                  />
                }
              >
                <Text fontSize={sectionFontSize}>
                  Synthetic images that cause extreme responses
                </Text>
              </Section>
              <Section
                title="Dataset Examples"
                icon={
                  <div
                    style={{
                      display: "flex",
                      width: iconWidth,
                      height: iconWidth,
                      flexFlow: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {range(4).map(i => (
                      <img
                        width={iconWidth / 2}
                        height={iconWidth / 2}
                        src={`https://storage.googleapis.com/clarity-public/nick/dataset_examples/mixed3b/342/bin0/image${i}.jpg`}
                      />
                    ))}
                  </div>
                }
              >
                <Text fontSize={sectionFontSize}>
                  Natural images that cause extreme responses
                </Text>
              </Section>
              <Section
                title="Tuning Curves"
                icon={
                  <img
                    width={iconWidth}
                    height={iconWidth}
                    background="tint1"
                    src={require("./images/tuning-banner.png")}
                  />
                }
              >
                <Text fontSize={sectionFontSize}>
                  Measuring responses to natural images
                </Text>
              </Section>
              <Section
                title="Synthetic Examples"
                icon={
                  <img
                    width={iconWidth}
                    height={iconWidth}
                    background="tint1"
                    src={require("./images/synthetic.png")}
                  />
                }
              >
                <Text fontSize={sectionFontSize}>
                  Measuring responses to synthetic images
                </Text>
              </Section>
            </Surface>
          </Surface>
          <Surface
            zIndex={10}
            //boxShadow="-5px 18px 40px -12px rgba(50,50,93,.4)"
            borderRadius={5}
            marginLeft={58}
            alignItems="center"
          >
            <RenderCofabComponent
              component={BannerRadial}
              folder="radial-tuning-curve"
            />
            <Text
              marginTop={30}
              transform="translateX(10px)"
              fontStyle="italic"
              size={500}
            >
              Neuron responses to synthetic curves projected radially
            </Text>
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
